import AdmissionsPage from "../components/pages/OtherClasses";

export default AdmissionsPage;
